/**
 * CASL — two roles: admin (full CRUD) and viewer (read-only).
 * Role is sourced from the Firebase auth store after login.
 */
import { createMongoAbility } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";
import { useAuthStore } from "@/stores/auth";
import { watch } from "vue";

export default function (app) {
  const ability = createMongoAbility([]);

  app.use(abilitiesPlugin, ability, { useGlobalProperties: true });

  // Update abilities when the auth store's role changes.
  const auth = useAuthStore();
  function applyRole(role) {
    if (role === "admin") {
      ability.update([{ action: "manage", subject: "all" }]);
    } else {
      ability.update([{ action: "read", subject: "all" }]);
    }
  }

  // Apply immediately if already logged in, then watch for changes.
  if (auth.isAuthenticated) applyRole(auth.role);
  watch(() => auth.role, applyRole);
}
